<template>
  <span class="email-address">
    <!-- no target is used as it causes issues with mobile redirection -->
    <a :href="'mailto:' + email">{{ label }}</a>
  </span>
</template>
<script>
export default {
  props: {
    email: {
      type: String,
      required: true
    },
    emailText: {
      type: String
    }
  },
  computed: {
    label() {
      return this.emailText || this.email;
    }
  }
};
</script>
